import { render, staticRenderFns } from "./dns.vue?vue&type=template&id=367062be&scoped=true"
import script from "./dns.vue?vue&type=script&lang=js"
export * from "./dns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367062be",
  null
  
)

export default component.exports